<template>
    <div class="selftrain-page-container">
        <!-- <TrainBlock v-for="item in selfTrainList" :key="item.category" :selfTrainItemList="item.selfTrainItemList"
            :category="item.category" @finishSelfTrainItem="handleFinishSelfTrainItem"></TrainBlock> -->

        <div class="pattern-container" v-if="selfTrainMap.weekday && selfTrainMap.weekday.length > 0">
            <div class="tag">工作日</div>
            <TrainBlock v-for="item in selfTrainMap.weekday" :key="item.category"
                :selfTrainItemList="item.selfTrainItemList" :category="item.category"
                @finishSelfTrainItem="handleFinishSelfTrainItem"></TrainBlock>
        </div>

        <div class="pattern-container" v-if="selfTrainMap.weekend && selfTrainMap.weekend.length > 0">
            <div class="tag">节假日</div>
            <TrainBlock v-for="item in selfTrainMap.weekend" :key="item.category"
                :selfTrainItemList="item.selfTrainItemList" :category="item.category"
                @finishSelfTrainItem="handleFinishSelfTrainItem"></TrainBlock>
        </div>

        <div class="pattern-container" v-if="selfTrainMap.everyday && selfTrainMap.everyday.length > 0">
            <div class="tag">每天</div>
            <TrainBlock v-for="item in selfTrainMap.everyday" :key="item.category"
                :selfTrainItemList="item.selfTrainItemList" :category="item.category"
                @finishSelfTrainItem="handleFinishSelfTrainItem"></TrainBlock>
        </div>
    </div>
</template>

<script>
import TrainBlock from "./components/TrainBlock";
export default {
    components: { TrainBlock },
    mounted() {
        let _self = this;
        _self.querySelfTrainList();
    },
    data() {
        return {
            selfTrainMap: {},
        };
    },
    methods: {
        // 查询自律清单
        querySelfTrainList() {
            let _self = this;
            _self.$api.selftrain
                .queryAllSelfTrainItems({})
                .then(
                    res => {
                        if (res.returnCode === 200) {
                            // let arr1 = res.data.map(category => {
                            //     let selfTrainItemList = category.selfTrainItemList;
                            //     let arr2 = selfTrainItemList.map(selfTrainItem => {
                            //         let now = new Date;
                            //         let d1 = new Date(now.getFullYear() + '-' + (now.getMonth() + 1).toString().padStart(2, '0') + '-' + now.getDate().toString().padStart(2, '0'));// 前端计算的当前日期
                            //         let d2 = new Date(selfTrainItem.lastFinishTime);// 后端传过来的上一次完成日期
                            //         if (d1.getTime() !== d2.getTime()) {// 如果两个日期相等,说明今天已经点过完成了
                            //             selfTrainItem.finishColor = '#ffffff';
                            //         }
                            //         return selfTrainItem;
                            //     })
                            //     category.selfTrainItemList = arr2;
                            //     return category;
                            // })
                            // _self.selfTrainList = arr1;
                            

                            let rawMap = res.data;
                            let resultMap = {};
                            function mapFun(category) {
                                let selfTrainItemList = category.selfTrainItemList;
                                let tempArr = selfTrainItemList.map(selfTrainItem => {
                                    let now = new Date;
                                    let d1 = new Date(now.getFullYear() + '-' + (now.getMonth() + 1).toString().padStart(2, '0') + '-' + now.getDate().toString().padStart(2, '0'));// 前端计算的当前日期
                                    let d2 = new Date(selfTrainItem.lastFinishTime);// 后端传过来的上一次完成日期
                                    if (d1.getTime() !== d2.getTime()) {// 如果两个日期相等,说明今天已经点过完成了
                                        selfTrainItem.finishColor = '#ffffff';
                                    }
                                    return selfTrainItem;
                                })
                                category.selfTrainItemList = tempArr;
                                return category;
                            }
                            resultMap.weekday = rawMap.weekday.map(mapFun);
                            resultMap.weekday = rawMap.weekend.map(mapFun);
                            resultMap.weekday = rawMap.everyday.map(mapFun);

                            _self.selfTrainMap = res.data;

                        } else {
                            _self.$toast.fail(res.returnMsg);
                        }
                    },
                    error => {
                        console.log(error);
                        _self.$toast.fail("服务器忙，请稍后重试");
                    }
                )
                .catch(err => {
                    console.log(err);
                });
        },
        // 完成自律项后的处理,需要重新查询一下自律清单
        handleFinishSelfTrainItem() {
            let _self = this;
            _self.querySelfTrainList();
        }
    },
}
</script>

<style scoped>
.selftrain-page-container {
    width: 100vw;
}

.selftrain-page-container .pattern-container {
    display: flex;
    flex-direction: column;
    padding-top: 16px;
    width: 94vw;
    margin: 0 auto;
    border: 2px dashed #D75F28;
    position: relative;
}

.selftrain-page-container .pattern-container:nth-child(n+2) {
    margin-top: 16px;
}

.selftrain-page-container .pattern-container .tag {
    position: absolute;
    top: -2px;
    left: -2px;
    background-color: #D75F28;
    color: white;
}
</style>